const func = (find, replace, $target) => {
	$target = $target ? $target : $(body);

	var n,
		walk = document.createTreeWalker($target[0], NodeFilter.SHOW_TEXT, null, false);
	while ((n = walk.nextNode())) {
		n.textContent = n.textContent.replace(new RegExp(find, 'g'), replace);
	}
};

export default func;
